export default __webpack_public_path__ + "static/media/instagram.fb0c08b4.svg";